import React from "react";
import { Modal as AntdModal } from "antd";
import styled from "styled-components";
import PropTypes from "prop-types";

const StyledModal = styled(AntdModal)`
  .ant-modal-content {
    border-radius: 30px;
    padding: 0;
    overflow: hidden;
  }

  .ant-modal-header {
    padding: 30px 30px 0 30px;
    border: none;
    border-radius: 30px 30px 0 0;
  }
  .ant-modal-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 140%;
    text-align: center;
  }

  .ant-modal-body {
    padding: 10px 16px 10px 16px;
    @media only screen and (min-width: 1024px) {
      padding: 20px 30px 20px 30px;
    }
  }

  .ant-modal-footer {
    padding: 0;
    border: none;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 0 30px 30px 30px;

    @media only screen and (min-width: 768px) {
      flex-direction: row-reverse;
      gap: 20px;
    }
  }

  .ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
    margin-left: 0;
  }
`;

const ContentWrapper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

/**
 * Reusable AntModal component based on antd Modal
 * @param {Object} props
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {function} props.onCancel - Callback when modal is closed
 * @param {React.ReactNode} props.children - Modal content
 * @param {string} [props.title] - Modal title
 * @param {React.ReactNode} [props.footer] - Modal footer
 * @param {string|number} [props.width] - Modal width (default: 600px)
 * @param {boolean} [props.closable] - Whether to show close button (default: true)
 * @param {boolean} [props.maskClosable] - Whether to close modal when clicking mask (default: true)
 * @param {string} [props.className] - Additional CSS class name
 * @param {Object} [props.rest] - Other props passed to the underlying Modal component
 */
export const AntModal = ({
  visible,
  onCancel,
  children,
  title,
  footer,
  width = 600,
  closable = true,
  maskClosable = closable,
  className,
  ...rest
}) => {
  return (
    <StyledModal
      visible={visible}
      onCancel={onCancel}
      title={title}
      footer={footer}
      width={width}
      closable={closable}
      maskClosable={maskClosable}
      className={className}
      centered
      {...rest}
    >
      <ContentWrapper>{children}</ContentWrapper>
    </StyledModal>
  );
};

AntModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  children: PropTypes.node,
  title: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  closable: PropTypes.bool,
  maskClosable: PropTypes.bool,
  className: PropTypes.string,
};

